import "./locales/i18n";
import "simplebar/src/simplebar.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import ApiProvider from "src/services/ApiProvider";

import { APP_ENV } from "./config.ts";
import RouterProvider from "./providers/RouterProvider.tsx";

Sentry.init({
	dsn: "https://4a2cf15193961d3167ec938f5cbf477d@o4508761762955264.ingest.de.sentry.io/4508761764528208",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
		Sentry.browserProfilingIntegration()
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["https://api.finlink.vumi.io"],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	environment: APP_ENV,
	beforeSend(event) {
		// Check if the event originates from localhost
		if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
			// Discard the event by returning null
			return null;
		}
		// Otherwise, send the event to Sentry
		return event;
	}
});

ReactDOM.createRoot(document.getElementById("root")! as HTMLElement).render(
	// @ts-ignore
	<HelmetProvider>
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<ApiProvider>
				<RouterProvider />
			</ApiProvider>
		</LocalizationProvider>
	</HelmetProvider>
);
